<script >
import ChartingStockWorkspaceMembership from '@/features/charting-next/components/workspace/ChartingStockWorkspaceMembership.vue';
import { ref, watch } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    type: Boolean,
    default: false
  },
  stock: {
    type: Object,
    default: null
  },
  favoriteFolders: {
    type: Array,
    default: () => []
  },
  canUseFavorites: {
    type: Boolean,
    default: false
  },
  isMutating: {
    type: Boolean,
    default: false
  },
  error: {
    type: String,
    default: ''
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  loadError: {
    type: [Object, String],
    default: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const attemptedChange = ref(false);
  watch(() => props.visible, () => {
    attemptedChange.value = false;
  });
  const toggleFolder = folderName => {
    attemptedChange.value = true;
    emit('toggle-folder', folderName);
  };
  return {
    emit,
    attemptedChange,
    toggleFolder
  };
};
__sfc_main.components = Object.assign({
  ChartingStockWorkspaceMembership
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
    <Dialog
        :visible="visible"
        modal
        dismissable-mask
        close-on-escape
        mask-class="charting-mobile-favorite-mask"
        dialog-class="charting-mobile-favorite-dialog"
        :dialog-style="{ width: '100%' }"
        @update:visible="emit('update:visible', $event)"
    >
        <template #header>
            <div>
                <div class="charting-mobile-favorite-sheet__title">Guardar {{ stock && stock.ticker }}</div>
            </div>
        </template>

        <ChartingStockWorkspaceMembership
            :stock="stock"
            :favorite-folders="favoriteFolders"
            :can-use-favorites="canUseFavorites"
            :is-mutating="isMutating"
            :is-loading="isLoading"
            :load-error="loadError"
            :error="attemptedChange ? error : ''"
            @toggle-folder="toggleFolder"
            @retry="emit('retry')"
        />
    </Dialog>
</template>

<style scoped>
.charting-mobile-favorite-sheet__title { margin-top: 0.2rem; font-size: 1.05rem; font-weight: 800; }
</style>

<style>
@media (max-width: 699px) {
    .p-dialog-mask.charting-mobile-favorite-mask { top: var(--modern-shell-header-height, 62px); align-items: flex-end; padding: 0; }
    .p-dialog.charting-mobile-favorite-dialog { width: 100% !important; max-width: none; max-height: min(72dvh, 38rem); border-radius: 1.35rem 1.35rem 0 0; padding-bottom: env(safe-area-inset-bottom); }
}
</style>
